/**
 * Zenoti Modal Functionality
 * Handles the modal interactions for Zenoti booking flow
 */

document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('zenoti-booking-modal');
  const closeBtn = document.querySelector('.zenoti-modal-close');
  let confirmBtn = document.getElementById('zenoti-confirm-booking');
  let bookingStatus = document.getElementById('zenoti-booking-status');
  let bookingResult = document.getElementById('zenoti-booking-result');
  let successResult = document.querySelector('.zenoti-success');
  let errorResult = document.querySelector('.zenoti-error');
  let errorMessage = document.getElementById('zenoti-error-message');
  let confirmationNumber = document.getElementById('zenoti-confirmation-number');
  
  // Login form elements
  let loginSection = document.getElementById('zenoti-login-section');
  let customerInfo = document.getElementById('zenoti-customer-info');
  let bookingDetails = document.getElementById('zenoti-booking-details');
  let bookingActions = document.querySelector('.zenoti-booking-actions');
  let loginButton = document.getElementById('zenoti-login-button');
  let loginEmail = document.getElementById('zenoti-login-email');
  let loginPassword = document.getElementById('zenoti-login-password');
  let loginError = document.querySelector('.zenoti-login-error');
  let loginErrorMessage = document.getElementById('zenoti-login-error-message');
  
  // Notes section elements
  let notesSection = document.getElementById('zenoti-notes-section');
  let notesTextarea = document.getElementById('zenoti-notes');
  
  // Store customer data if available from Liquid
  if (typeof Shopify !== 'undefined' && Shopify.customer) {
    window.customerData = {
      id: Shopify.customer.id,
      firstName: Shopify.customer.first_name,
      lastName: Shopify.customer.last_name,
      email: Shopify.customer.email,
      phone: Shopify.customer.phone
    };
  }
  
  // Close modal when clicking the X button
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      modal.style.display = 'none';
      
      // Simple page refresh to reset everything
      window.location.reload();
    });
  }
  
  // Close modal when clicking outside the modal content
  window.addEventListener('click', function(event) {
    if (event.target === modal) {
      modal.style.display = 'none';
      
      // Simple page refresh to reset everything
      window.location.reload();
    }
  });
  
  // Login button
  if (loginButton) {
    loginButton.addEventListener('click', function() {
      handleLogin();
    });
  }
  
  // Handle Enter key in password field
  if (loginPassword) {
    loginPassword.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        handleLogin();
      }
    });
  }
  
  // Confirm booking button
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function() {
      // Check if button is disabled
      if (confirmBtn.disabled) {
        return;
      }
      
      // Check if user is logged in first
      if (!window.customerData) {
        // If not logged in, ensure login form is visible
        updateViewBasedOnAuth(); 
      } else {
        handleZenotiBooking();
      }
    });
  }
  
  // Function to reset modal state
  function resetModalState() {
    if (bookingStatus) bookingStatus.style.display = 'none';
    if (bookingResult) bookingResult.style.display = 'none';
    if (successResult) successResult.style.display = 'none';
    if (errorResult) errorResult.style.display = 'none';
    if (loginError) loginError.style.display = 'none';
    
    // Reset login form if it exists
    if (loginEmail) loginEmail.value = '';
    if (loginPassword) loginPassword.value = '';
    
    // Reset notes if it exists
    if (notesTextarea) notesTextarea.value = '';
    
    // Reset confirm button to original state
    if (confirmBtn) {
      confirmBtn.textContent = 'Request Booking';
      confirmBtn.disabled = false;
    }
    
    // Reset any selected payment method
    const selectedCardRadio = document.querySelector('input[name="savedCard"]:checked');
    if (selectedCardRadio) {
      selectedCardRadio.checked = false;
    }
    
    // Clear customer access token (but NOT zenotiBookingData - it's set fresh each time)
    window.customerAccessToken = null;
    
    // Show appropriate sections based on authentication state
    updateViewBasedOnAuth();
  }
  
  // Function to update the view based on authentication state
function updateViewBasedOnAuth() {
  const isAuthenticated = !!window.customerData;
  
  // Always show booking actions, but enable/disable the button
  if (bookingActions) bookingActions.style.display = 'flex';
  
  // Update button state after showing actions
  updateBookingButtonState();
  
  // If customer is logged in
  if (isAuthenticated) {
    if (loginSection) loginSection.style.display = 'none';
    // Show all booking details sections
    const allBookingDetails = document.querySelectorAll('#zenoti-booking-details');
    allBookingDetails.forEach(element => {
      element.style.display = 'block';
    });
    
    // Show booking completion section
    const bookingCompletion = document.getElementById('zenoti-booking-completion');
    if (bookingCompletion) bookingCompletion.style.display = 'block';
    
    // Always show notes section for now (no payment method dependency)
    if (notesSection) {
      notesSection.style.display = 'block';
    }
    
    // Create and show personalized welcome message
    populateGuestDetails();
    
    // Update button state (simplified - no payment validation)
    updateBookingButtonState();
  } 
  // If customer is not logged in and login section exists
  else if (loginSection) {
    loginSection.style.display = 'block';
    // Keep booking details visible - users need to see what they're booking
    const allBookingDetails = document.querySelectorAll('#zenoti-booking-details');
    allBookingDetails.forEach(element => {
      element.style.display = 'block';
    });
    if (notesSection) notesSection.style.display = 'none';
    
    // Hide welcome message if it exists
    hidePersonalizedWelcome();
    
    // Populate guest details (will show login form if no Zenoti data)
    populateGuestDetails();
  }
}

// Function to populate guest details from Zenoti customer data
function populateGuestDetails() {
  const customerInfoSection = document.getElementById('zenoti-customer-info');
  const loginSection = document.getElementById('zenoti-login-section');
  
  // Check if we have Zenoti customer data
  if (window.zenotiCustomerData && window.zenotiCustomerData.personal_info) {
    const personalInfo = window.zenotiCustomerData.personal_info;
    
    // Populate customer info fields
    const nameSpan = document.getElementById('zenoti-customer-name');
    const emailSpan = document.getElementById('zenoti-customer-email');
    const phoneSpan = document.getElementById('zenoti-customer-phone');
    
    if (nameSpan) {
      nameSpan.textContent = `${personalInfo.first_name || ''} ${personalInfo.last_name || ''}`.trim();
    }
    
    if (emailSpan) {
      emailSpan.textContent = personalInfo.email || '';
    }
    
    if (phoneSpan) {
      const mobilePhone = personalInfo.mobile_phone;
      if (mobilePhone && mobilePhone.number) {
        phoneSpan.textContent = `+${mobilePhone.country_code || ''} ${mobilePhone.number || ''}`.trim();
      } else {
        phoneSpan.textContent = 'Not provided';
      }
    }
    
    // Show customer info, hide login section
    if (customerInfoSection) customerInfoSection.style.display = 'block';
    if (loginSection) loginSection.style.display = 'none';
    
    console.log('Guest details populated from Zenoti data:', personalInfo);
  } else {
    // No Zenoti data available, show login section
    if (customerInfoSection) customerInfoSection.style.display = 'none';
    if (loginSection) loginSection.style.display = 'block';
    
    console.log('No Zenoti customer data available, showing login form');
  }
}

// Function to hide personalized welcome message
function hidePersonalizedWelcome() {
  const welcomeSection = document.getElementById('zenoti-dynamic-welcome');
  if (welcomeSection) {
    welcomeSection.remove();
  }
}
  
  // Function to show login error
  function showLoginError(message) {
    if (loginError) loginError.style.display = 'block';
    if (loginErrorMessage) loginErrorMessage.textContent = message;
  }

  // Function to handle login
  async function handleLogin() {
    // Validate form
    if (!loginEmail || !loginPassword || !loginEmail.value || !loginPassword.value) {
      showLoginError('Please enter both email and password.');
      return;
    }
    
    // Disable login button and show loading state
    loginButton.disabled = true;
    loginButton.textContent = 'Logging in...';
    loginButton.classList.add('zenoti-login-btn-loading');
    if (loginError) loginError.style.display = 'none';
    
    try {
      // Call your server-side authentication endpoint
      const response = await fetch('/apps/spa-booking/api/customers/authenticate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: loginEmail.value,
          password: loginPassword.value
        })
      });
      
      const data = await response.json();
      
      if (!data.success) {
        showLoginError(data.message || 'Authentication failed');
        return;
      }
      // Authentication successful
      window.customerData = data.customer;
      window.customerAccessToken = data.accessToken;
      console.log('Customer authenticated:', window.customerData);
      console.log('Access token stored:', window.customerAccessToken.substring(0, 10) + "...");
      
      // Find or create Zenoti guest to ensure backend has the same customer
      try {
        const guestResponse = await fetch('/apps/spa-booking/api/guests/find-or-create', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.customerAccessToken}`
          },
          body: JSON.stringify({
            email: data.customer.email,
            first_name: data.customer.firstName || '',
            last_name: data.customer.lastName || '',
            phone: data.customer.phone || '',
            include_saved_cards: true  // Add this line

          })
        });
        
        const guestData = await guestResponse.json();
        
        if (guestResponse.ok && guestData.guest) {
          console.log('Zenoti guest found/created:', guestData.guest);
          // Store the Zenoti guest ID for use in booking

          // Insert defaults for testing 

          if(!guestData.guest.savedCards || guestData.guest.savedCards.length === 0) {
            guestData.guest.savedCards = [
              {
                "account_id": "11ADA4D4-5FC9-46D4-8CB6-B1C532DB4CC4",
                "card_logo": "visa",
                "last_four": "1234",
                "expiry_on": "12/25"
              },
              {
                "account_id": "22BDB5E5-6FD0-57E5-9DC7-C2D643EC5DD5",
                "card_logo": "mastercard", 
                "last_four": "5678",
                "expiry_on": "08/26"
              }
            ];
          }
            
          window.zenotiCustomerData = guestData.guest;
          
          //displaySavedCards(guestData.guest?.savedCards || []);
          console.log('DisplayCards Disabled');
        } else {
          console.warn('Failed to find/create Zenoti guest:', guestData.error);
          // Continue anyway - we'll handle this in the booking process
        }
      } catch (guestError) {
        console.error('Error creating Zenoti guest:', guestError);
        // Continue anyway - we'll handle this in the booking process
      }
      
      // Update the view based on authentication state
      updateViewBasedOnAuth();
      
      // Ensure button state is updated after login
      updateBookingButtonState();
      
    } catch (error) {
      console.error('Login error:', error);
      showLoginError('An error occurred during login. Please try again.');
    } finally {
      // Reset login button
      if (loginButton) {
        loginButton.disabled = false;
        loginButton.textContent = 'Log In';
        loginButton.classList.remove('zenoti-login-btn-loading');
      }
    }
  }
  
  // Function to handle Zenoti booking
  async function handleZenotiBooking() {
    if (!window.zenotiBookingData) {
      showError('Booking data is missing.');
      return;
    }
    
    console.log('=== ZENOTI BOOKING DEBUG ===');
    console.log('Original zenotiBookingData:', window.zenotiBookingData);
    
    // Add notes and customer data to booking data
    const notes = notesTextarea ? notesTextarea.value.trim() : '';
    const selectedCard = getSelectedCardInfo();

    // Determine the correct service ID
    let finalServiceId = window.zenotiBookingData.serviceId;
    const service = window.zenotiBookingData.service;
    const treatment = window.zenotiBookingData.treatments;
    
    console.log('Service:', service);
    console.log('Treatment:', treatment);
    console.log('Original serviceId:', finalServiceId);
    
    // If service is "Book A Treatment" and we have a treatment, resolve the service ID
    if (service === 'Book A Treatment' && treatment) {
      // Step 1: Convert treatment handle to display name using TREATMENT_SERVICE_MAP
      const treatmentName = window.TREATMENT_SERVICE_MAP?.[treatment];
      console.log('Treatment handle → name:', treatment, '→', treatmentName);
      
      // Step 2: Look up service ID using the display name
      if (treatmentName) {
        const treatmentServiceId = window.SERVICE_ID_MAP?.[treatmentName];
        if (treatmentServiceId) {
          finalServiceId = treatmentServiceId;
          console.log('✓ Replaced serviceId with treatment-specific ID:', finalServiceId);
        } else {
          console.warn('⚠ No service ID found for treatment name:', treatmentName);
          console.warn('Available service IDs:', window.SERVICE_ID_MAP ? Object.keys(window.SERVICE_ID_MAP) : 'SERVICE_ID_MAP not loaded');
        }
      } else {
        console.warn('⚠ No treatment name mapping found for handle:', treatment);
        console.warn('Available mappings:', window.TREATMENT_SERVICE_MAP ? Object.keys(window.TREATMENT_SERVICE_MAP) : 'TREATMENT_SERVICE_MAP not loaded');
      }
    }
    
    // Map the booking data to the expected API format
    const bookingDataWithNotes = {
      service: service,
      date: window.zenotiBookingData.date,
      time: window.zenotiBookingData.time,
      center: window.zenotiBookingData.center,
      centerId: window.zenotiBookingData.centerId,
      serviceId: finalServiceId,
      customer: window.customerData,
      zenotiCustomer: window.zenotiCustomerData,
      notes: notes,
      treatment: treatment,
      skinConcerns: window.zenotiBookingData.skinConcerns,
      preferredPaymentMethod: selectedCard
    };
    
    console.log('Final booking data to send:', bookingDataWithNotes);
    console.log('=== END DEBUG ===');
    
    // Show loading state
    bookingStatus.style.display = 'block';
    confirmBtn.disabled = true;
    
    try {
      // Make API call to request Zenoti booking
      const headers = {
        'Content-Type': 'application/json'
      };
      
      // Add authentication header if we have an access token
      if (window.customerAccessToken) {
        headers['Authorization'] = `Bearer ${window.customerAccessToken}`;
      }
      
      const response = await fetch('/apps/spa-booking/api/appointments/request-booking', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bookingDataWithNotes)
      });
      
      const data = await response.json();
      
      if (data.success) {
        // Show success message with booking ID
        const bookingId = data.booking.id;
        showSuccess(bookingId);
      } else {
        // Show error message
        showError(data.message || 'Unable to create booking request. Please try again or contact support.');
      }
    } catch (error) {
      console.error('Error making Zenoti booking:', error);
      showError('An unexpected error occurred. Please try again later.');
    } finally {
      // Hide loading state
      bookingStatus.style.display = 'none';
      confirmBtn.disabled = false;
    }
  }
  
  // Function to show success message
function showSuccess(bookingId) {
  // Hide all other sections
  hideAllSections();
  
  // Show the result
  bookingResult.style.display = 'block';
  successResult.style.display = 'block';
  errorResult.style.display = 'none';
  confirmationNumber.textContent = bookingId;
  
  // Clear local booking cache so subsequent bookings reflect updated slots
  if (typeof window.clearBookingCache === 'function') {
    window.clearBookingCache();
  }
  
  // Change confirm button to "Done"
  confirmBtn.textContent = 'Done';
  confirmBtn.addEventListener('click', function onDoneClick() {
    modal.style.display = 'none';
    
    // Simple page refresh to reset everything
    window.location.reload();
  }, { once: true });
}
  // Function to show error message
function showError(message) {
  // Hide all other sections
  hideAllSections();
  
  // Show the result
  bookingResult.style.display = 'block';
  successResult.style.display = 'none';
  errorResult.style.display = 'block';
  errorMessage.textContent = message;
  
  // Change confirm button to "Try Again"
  confirmBtn.textContent = 'Try Again';
  confirmBtn.disabled = false;
  
  // Remove any existing click listeners and add new one
  const newConfirmBtn = confirmBtn.cloneNode(true);
  confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
  
  // Update the reference
  confirmBtn = newConfirmBtn;
  
  confirmBtn.addEventListener('click', function onTryAgainClick() {
    modal.style.display = 'none';
    
    // Simple page refresh to reset everything
    window.location.reload();
  });
  
  // Add a close button option
  const closeBtn = document.querySelector('.zenoti-modal-close');
  if (closeBtn) {
    closeBtn.style.display = 'block';
  }
}

// Function to hide all sections except the result
function hideAllSections() {
  // Hide welcome section
  const welcomeSection = document.getElementById('zenoti-dynamic-welcome');
  if (welcomeSection) welcomeSection.style.display = 'none';
  
  // Hide all booking details sections
  const allBookingDetails = document.querySelectorAll('#zenoti-booking-details');
  allBookingDetails.forEach(element => {
    element.style.display = 'none';
  });
  
  // Hide booking completion section
  const bookingCompletion = document.getElementById('zenoti-booking-completion');
  if (bookingCompletion) bookingCompletion.style.display = 'none';
  
  // Hide saved cards section
  const cardsSection = document.getElementById('zenoti-saved-cards-section');
  if (cardsSection) cardsSection.style.display = 'none';
  
  // Hide notes section
  if (notesSection) notesSection.style.display = 'none';
  
  // Hide login section
  if (loginSection) loginSection.style.display = 'none';
}
// Function to update booking button state (simplified - no payment validation)
function updateBookingButtonState() {
  console.log('UpdateBookingButtonState', confirmBtn);
  if (!confirmBtn) return;
  
  // Since we don't have payment processing, just check basic requirements
  const hasDate = window.selectedDate;
  const hasTime = window.selectedTime;
  const hasCenter = window.selectedCenter;
  
  if (!hasDate || !hasTime || !hasCenter) {
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Please select date, time, and center';
    return;
  }
  
  // Enable the button if basic requirements are met
  confirmBtn.disabled = false;
  confirmBtn.textContent = 'Request Booking';
}

// Function to display saved cards in the UI
function displaySavedCards(savedCards) {
  const cardsSection = document.getElementById('zenoti-saved-cards-section');
  const cardsList = document.getElementById('zenoti-cards-list');
  
  if (!cardsSection || !cardsList) {
    return;
  }
  
  // If no saved cards, show message and disable booking
  if (!savedCards || savedCards.length === 0) {
    cardsSection.style.display = 'block';
    cardsList.innerHTML = `
      <div class="zenoti-no-cards-message">
        <h4>No Payment Method on File</h4>
        <p>We don't have your credit card information on file. Please try again as "New Patient" or contact us to add a payment method.</p>
      </div>
    `;
    // Hide notes section when no cards available
    if (notesSection) notesSection.style.display = 'none';
    // Disable booking button
    updateBookingButtonState();
    return;
  }
  
  // Show the cards section
  cardsSection.style.display = 'block';
  if (notesSection) notesSection.style.display = 'block';

  // Clear existing cards
  cardsList.innerHTML = '';
  
  // Create radio buttons for each card
  savedCards.forEach((card, index) => {
    const cardElement = document.createElement('div');
    cardElement.className = 'zenoti-card-option';
    
    const cardLogo = getCardLogo(card.card_logo);
    
    cardElement.innerHTML = `
      <label class="zenoti-card-label">
        <input type="radio" name="selected_card" value="${card.account_id}" ${index === 0 ? 'checked' : ''}>
        <div class="zenoti-card-display">
          <span class="zenoti-card-logo">${cardLogo}</span>
          <span class="zenoti-card-details">
            <span class="zenoti-card-number">**** **** **** ${card.last_four}</span>
            <span class="zenoti-card-expiry">Expires ${card.expiry_on}</span>
          </span>
        </div>
      </label>
    `;
    
    cardsList.appendChild(cardElement);
  });
  
  // Add event listeners to radio buttons to update button state
  const radioButtons = cardsList.querySelectorAll('input[name="selected_card"]');
  radioButtons.forEach(radio => {
    radio.addEventListener('change', updateBookingButtonState);
  });
  
  // Update button state after displaying cards
  updateBookingButtonState();
}

// Helper function to get card logo emoji
function getCardLogo(cardType) {
  const logos = {
    'visa': '💳',
    'mastercard': '💳',
    'amex': '💳',
    'discover': '��',
    'default': '💳'
  };
  return logos[cardType] || logos.default;
}

// Function to get selected card info
function getSelectedCardInfo() {
  const selectedCard = document.querySelector('input[name="selected_card"]:checked');
  if (!selectedCard) return null;
  
  if (selectedCard.value === 'new_card') {
    return { useNewCard: true };
  }
  
  // Find the card details from savedCards
  const savedCards = window.zenotiCustomerData?.savedCards || [];
  const selectedCardData = savedCards.find(card => card.account_id === selectedCard.value);
  
  return selectedCardData ? {
    useNewCard: false,
    account_id: selectedCardData.account_id,
    last_four: selectedCardData.last_four,
    expiry_on: selectedCardData.expiry_on,
    card_logo: selectedCardData.card_logo
  } : null;
}

// Function to populate booking details in the modal
function populateBookingDetails() {
  console.log("Populating booking details", window.zenotiBookingData)
  if (!window.zenotiBookingData) {
    console.log('No booking data available to populate');
    return;
  }
  
  const data = window.zenotiBookingData;
  
  // Populate service
  const serviceElement = document.getElementById('zenoti-service');
  if (serviceElement && data.service) {
    serviceElement.textContent = data.service;
  }
  
  // Populate treatment if exists
  const treatmentElement = document.getElementById('zenoti-treatment');
  if (treatmentElement) {
    if (data.treatments) {
      // Convert treatment handle to display name using TREATMENT_SERVICE_MAP
      const treatmentHandle = data.treatments;
      const treatmentName = window.TREATMENT_SERVICE_MAP?.[treatmentHandle] || treatmentHandle;
      treatmentElement.textContent = `Treatment: ${treatmentName}`;
      console.log('Treatment populated:', treatmentHandle, '→', treatmentName);
    } else {
      treatmentElement.textContent = '';
    }
  }
  
  // Populate center
  const centerElement = document.getElementById('zenoti-center');
  if (centerElement && data.center) {
    centerElement.textContent = data.center;
  }
  
  // Populate date
  const dateElement = document.getElementById('zenoti-date');
  if (dateElement && data.date) {
    dateElement.textContent = data.date;
  }
  
  // Populate time
  const timeElement = document.getElementById('zenoti-time');
  if (timeElement && data.time) {
    timeElement.textContent = ` at ${data.time}`;
  }
  
  // Populate skin concerns
  const concernElement = document.getElementById('zenoti-concern');
  if (concernElement) {
    let concernsText = '';
    if (data.skinConcerns) {
      if (Array.isArray(data.skinConcerns) && data.skinConcerns.length > 0) {
        console.log('zenoti-modal.js: skinConcerns is an array', data.skinConcerns);
        concernsText = `Concerns: ${data.skinConcerns.join(', ')}`;
      } else if (typeof data.skinConcerns === 'string' && data.skinConcerns.trim()) {
        console.log('zenoti-modal.js: skinConcerns is a string', data.skinConcerns);
        concernsText = `Concerns: ${data.skinConcerns}`;
      } else {
        console.log('zenoti-modal.js: skinConcerns is not an array or string -- hide it', data.skinConcerns);
      }
    }
    concernElement.textContent = concernsText;
  }
  
  console.log('Booking details populated from zenotiBookingData');
}

// Function to ensure modal is properly initialized when opened
function initializeModal() {
  // Reset modal state to ensure clean start
  resetModalState();
  
  // Ensure close button is visible
  const closeBtn = document.querySelector('.zenoti-modal-close');
  if (closeBtn) {
    closeBtn.style.display = 'block';
  }
  
  // Populate booking details from window.zenotiBookingData
  populateBookingDetails();
  
  // Populate guest details based on Zenoti data
  populateGuestDetails();
  
  console.log('Modal initialized and reset');
}

// Expose the initialization function globally so it can be called when modal opens
window.initializeZenotiModal = initializeModal;
});